// extracted by mini-css-extract-plugin
module.exports = {"inputswitch":"styles_inputswitch__qA9FI","invalid":"styles_invalid__bw0uv","inputswitchform":"styles_inputswitchform__8AtAd"};